"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseWLUrl = void 0;
var AFF_SUB_5_PARAMS = {
  usource: "utm_source",
  umedium: "utm_medium",
  ucampaign: "utm_campaign"
};
var parseAffSub5 = function parseAffSub5(affSub5) {
  return affSub5.split("|").map(function (param) {
    return param.split("=");
  }).filter(function (pair) {
    return AFF_SUB_5_PARAMS[pair[0]];
  }).map(function (pair) {
    return AFF_SUB_5_PARAMS[pair[0]] + "=" + pair[1];
  }).join("&");
};
var getPartnerLocationSearch = function getPartnerLocationSearch(url) {
  return ["aff_id", "aff_sub5"].map(function (param) {
    var value = url.searchParams.get(param);
    if (value && param === "aff_sub5") {
      return parseAffSub5(value);
    }
    if (value) {
      return param + "=" + url.searchParams.get(param);
    }
    return undefined;
  }).filter(function (str) {
    return str;
  }).join("&");
};
var getPartnerLocation = function getPartnerLocation(url) {
  var search = getPartnerLocationSearch(url);
  return "" + url.origin + url.pathname + (search ? "?" + search : "");
};
var getWLLocationSearch = function getWLLocationSearch(url) {
  return ["aff_id", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].map(function (param) {
    return url.searchParams.get(param) ? param + "=" + url.searchParams.get(param) : "";
  }).filter(function (str) {
    return str;
  }).join("&");
};
var getWLLocation = function getWLLocation(url) {
  var search = getWLLocationSearch(url);
  return "" + url.origin + url.pathname + (search ? "?" + search : "");
};
var parseWLUrl = function parseWLUrl(urlString) {
  try {
    var url = new URL(urlString);
    return {
      wlLocation: getWLLocation(url),
      partnerLocation: getPartnerLocation(url),
      fullURL: urlString
    };
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
exports.parseWLUrl = parseWLUrl;